import { LocalCache } from 'apollo-client';
import {
  brandNames,
  modelNames,
  powerSupplies,
  gearTypes,
  tractionTypes,
  vendorType,
  regions,
  defaultRegions,
  provinces,
  isPriceTiedToLoan,
  isVehicleCoveredByWarranty,
  interiorColors,
  coatingColors,
  priceLabels,
  vehicleRegistrationDateISO8601,
  engineDisplacementInCM3,
  powerInHP,
  priceInEUR,
  vehicleKM,
  modelVersions,
  comparison,
  websites,
  optionals,
  prediction,
  vehicleTypes,
  isPictureAvailable,
  isVATDeductible,
  country,
} from 'cache';
import { Country, VendorType } from 'generated/graphql';

export const removeFilter = (filterName: keyof LocalCache, chipName: string): void => {
  switch (filterName) {
    case 'brandNames':
      brandNames(...[brandNames()?.filter((brand) => brand !== chipName)]);
      break;
    case 'modelVersions':
      modelVersions(...[modelVersions()?.filter(({ value }) => value !== chipName)]);
      break;
    case 'vehicleTypes':
      vehicleTypes(...[vehicleTypes()?.filter((vehicleType) => vehicleType !== chipName)]);
      break;
    case 'optionals':
      optionals(...[optionals()?.filter((optional) => optional !== chipName)]);
      break;
    case 'modelNames':
      modelNames(...[modelNames()?.filter((model) => model !== chipName)]);
      break;
    case 'powerSupplies':
      powerSupplies(...[powerSupplies()?.filter((ps) => ps !== chipName)]);
      break;
    case 'gearTypes':
      gearTypes(...[gearTypes()?.filter((gear) => gear !== chipName)]);
      break;
    case 'tractionTypes':
      tractionTypes(...[tractionTypes()?.filter((traction) => traction !== chipName)]);
      break;
    case 'vendorType':
      vendorType(VendorType.Dealer);
      break;
    case 'regions':
      regions(...[regions()?.filter((r) => r !== chipName)]);
      break;
    case 'websites':
      websites(...[websites()?.filter((r) => r !== chipName)]);
      break;
    case 'provinces':
      provinces(...[provinces()?.filter((x) => x !== chipName)]);
      break;
    case 'priceLabels':
      priceLabels(...[priceLabels()?.filter((x) => x !== chipName)]);
      break;
    case 'coatingColors':
      coatingColors(...[coatingColors()?.filter((x) => x !== chipName)]);
      break;
    case 'interiorColors':
      interiorColors(...[interiorColors()?.filter((x) => x !== chipName)]);
      break;
    case 'isPriceTiedToLoan':
      isPriceTiedToLoan(undefined);
      break;
    case 'isVehicleCoveredByWarranty':
      isVehicleCoveredByWarranty(undefined);
      break;
    case 'isPictureAvailable':
      isPictureAvailable(undefined);
      break;
    case 'isVATDeductible':
      isVATDeductible(undefined);
      break;
    case 'vehicleRegistrationDateISO8601':
      vehicleRegistrationDateISO8601({});
      break;
    case 'engineDisplacementInCM3':
      engineDisplacementInCM3({});
      break;
    case 'powerInHP':
      powerInHP({});
      break;
    case 'priceInEUR':
      priceInEUR({});
      break;
    case 'vehicleKM':
      vehicleKM({});
      break;
    case 'country':
      country(Country.Italy);
      break;
    default:
      break;
  }
};

export const onResetFilters = (): void => {
  modelNames([]);
  optionals([]);
  vendorType(VendorType.Dealer);
  brandNames([]);
  powerSupplies([]);
  gearTypes([]);
  tractionTypes([]);
  regions(defaultRegions());
  provinces([]);
  interiorColors([]);
  coatingColors([]);
  isPriceTiedToLoan(undefined);
  isPictureAvailable(undefined);
  isVATDeductible(undefined);
  isVehicleCoveredByWarranty(undefined);
  vehicleTypes(undefined);
  priceLabels([]);
  modelVersions([]);
  comparison({});
  vehicleKM({});
  vehicleRegistrationDateISO8601({});
  prediction({});
  websites([]);
  powerInHP({});
  engineDisplacementInCM3({});
  priceInEUR({});
  country(Country.Italy);
};
